const audit = {
  title: "Code Audit — Multi-Hat Review",
  subtitle: "Reviewing code from 4 angles: plan, reality, quality & integrity",
  backToAdmin: "Back to Dev Log",
  passed: "Pass",
  warnings: "Warnings",
  failures: "Failures",
  infoItems: "Info",
  totalChecks: "Total Checks",
  filterBy: "Filter by",
  filterAll: "All",
  noChecks: "No checks to display",
  summaryTitle: "Summary by Hat",
  hat: "Hat",
  score: "Score",
  overall: "Overall",
  resultPass: "Pass",
  resultWarn: "Warning",
  resultFail: "Fail",
  resultInfo: "Info",
  recommendation: "Recommendation:",
  passCount: "pass",
  warnCount: "warn",
  failCount: "fail",
  infoCount: "info",
  totalLabel: "Total",
} as const;
export default audit;
